import url_ from "asset-data:assets/galleries/test/L1000398-color_55361ee1c3__1600.jpg";
export const url = url_;